import { builder } from '../utils/queryBuilder'
import Fetch from './Fetch'
import { BASE_URL } from '../config/config'
import { userTypes } from '../redux/user/userTypes'

export const getAllTickets = async (body, role, dispatch) => {
    const params = builder({
        id: body?.id,
        name: body?.name,
        take: body.take,
        skip: body.skip,
        status: body.status,
    })
    if (role === 'customer') {
        dispatch({
            type: userTypes.UPDATE_IS_NEW_TICKET_TO_FALSE_START,
        })
        return await Fetch.get(`${BASE_URL}ticketing/${params}`)
    } else if (role === 'admin') {
        return await Fetch.get(`${BASE_URL}ticketing/admin${params}`)
    }
}

export const updateATicket = async (id, body, role) => {
    if (role === 'customer') {
        return await Fetch.patch(`${BASE_URL}ticketing/${id}`, body)
    } else if (role === 'admin') {
        return await Fetch.patch(`${BASE_URL}ticketing/admin/${id}`, body)
    }
}
export const createATicket = async body => {
    return await Fetch.post(`${BASE_URL}ticketing`, {
        title: body?.title,
        section: 'TECHNICAL', //body?.section,
        text: body?.text,
        url: body?.url,
    })
}
